import DoneIcon from '@material-ui/icons/Done'
import RemoveIcon from '@material-ui/icons/Remove'
import React from 'react'
import Column from './Column'

export default class ActiveColumn extends Column {
  render = row =>
    row[this.field] ? (
      <DoneIcon color="secondary" />
    ) : (
      <RemoveIcon color="action" />
    )
}
